<template>
  <v-snackbar
    :model-value="SnackBarComponent.SnackbarVmodel"
    elevation="24"
    :color="SnackBarComponent.SnackbarColor"
    loaction="top"
  >
    <div class="text-center">{{ SnackBarComponent.SnackbarText }}</div>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    SnackBarComponent: Object,
  },
};
</script>
